import React, { useMemo, useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  MediumFont,
  PopupForm,
  TextArea,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { editDetails } from "../../../store/reducers/authReducer";
import Switcher from "../../common/switcher/Switcher";

const ChangeCCnew = ({ init, ind, guestsByTable = {}, tableAmount = 0 }) => {
  const { user } = useSelector((state) => state.authReducer);
  const [d, sD] = useState(user.tablesArray[ind]?.default || false);
  const dispatch = useDispatch();

  // Calculate total seated guests
  const totalSeated = Object.values(guestsByTable).reduce((sum, guest) => {
    return sum + (parseInt(guest.accept) || 0);
  }, 0);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    let s;
    let a;
    let c;
    let newArray = [];

    for (let i = 0; i < user.tablesArray.length; i++) {
      s = i + "title";
      a = i + "amount";
      c = i + "chairs";
      newArray.push({
        amount: parseInt(user.tablesArray[i].amount),
        chairs:
          i == ind ? parseInt(data.cc) : parseInt(user.tablesArray[i].chairs),
        default: i == ind ? d : user.tablesArray[i]?.default || false,
        title: user.tablesArray[i].title,
        x: user.tablesArray[i].x,
        y: user.tablesArray[i].y,
        width: user.tablesArray[i].width,
        height: user.tablesArray[i].height,
        shape: user.tablesArray[i].shape || "square", // Save the shape
        rotation: user.tablesArray[i].rotation || 0, // Save the rotation
      });
    }
    setLoading(true);
    dispatch(editDetails({ tablesArray: [...newArray] })).then((res) => {
      setLoading(false);
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  let height = window.screen.availHeight;
  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      style={{ height: "min-content", maxHeight: `${height * 0.8}px` }}
    >
      <div
        style={{
          width: "96%",
          margin: "15px auto",
        }}
      >
        {/* Display table capacity and seated count */}
        <div
          style={{
            marginBottom: "15px",
            padding: "8px 12px",
            background: "#f8f9fa",
            borderRadius: 4,
            border: "1px solid #e9ecef",
            fontSize: "14px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >
          מכיל: {tableAmount} / הושבו: {totalSeated}
        </div>

        <FlexRowBetween>
          <div style={{ width: "50%" }}>
            <Label>עריכות שנותרו</Label>
            <Input
              defaultValue={user.tablesArray[ind].chairs}
              type="number"
              {...register("cc", {
                required: true,
                min: 0,
                max: 300,
              })}
            />
            {CFV(`cc`, `מספר בין 0 ל 300`, errors)}
          </div>

          <div style={{ width: "40%", textAlign: "left" }}>
            <FlexRowBetween>
              <Label>התמלא!</Label>
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#d83535"}
                checked={d}
                onChange={() => sD(!d)}
              />
              <Label>נתונים</Label>
            </FlexRowBetween>
          </div>
        </FlexRowBetween>

        <FlexRowBetween style={{ marginTop: "30px" }}>
          <Button style={{ width: "100%" }}>שמירה</Button>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}
    </PopupForm>
  );
};

export default ChangeCCnew;
